export function isNumber(value: unknown): value is number {
  return typeof value === 'number';
}

export function assertIsNumber(value: unknown): asserts value is number {
  if (!isNumber(value)) {
    throw new TypeError(`Value is not of type number.`);
  }
}

export function createNumericLiteral<T extends number>(value: T): T {
  return value;
}
